import React, { useEffect, useState } from "react";
import NoDataItem from "../NoDataItem";
import { BsCollection, BsFilePlus, BsPlug } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import NewCollectionModal from "./NewCollectionModal";
import { BiCopy, BiLogoPython, BiPlus, BiQuestionMark, BiStop } from "react-icons/bi";
import APIConnectorModal from "./APIConnectorModal";
import LoadingDB from "../LoadingDb";
import ErrorPage from "../../../../Components/ErrorPage";
import OpenCollectionJson from "./OpenCollectionJson";
import OpenCollectionTable from "./OpenCollectionTable";
import { TbGalaxy, TbPlus, TbReload } from "react-icons/tb";
import NewRecordCollectionModal from "./NewRecordCollectionModal";
import { Dropdown } from "react-bootstrap";
import DeleteRecordModal from "../../../ViewComponents/DeleteRecordModal";
import CodeEditor from "./CodeEditor";
import { LuChevronFirst, LuChevronLast } from "react-icons/lu";

const MainData = ({ fetchRecords, records }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const { project_id, db_id, coll_id } = useParams()
    const [viewType, setViewType] = useState("table_view")
    const [loadingCollection, setLoadingCollection] = useState(true);
    const [error, setError] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [showAPIConn, setShowApiConn] = useState(false)
    const [collectionDetails, setCollectionDetails] = useState({})
    const [collectionData, setCollectionData] = useState([])
    const [openModalNewRec, setOpenModalNewRec] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [recordObject, setRecordObject] = useState({})
    const [copied, setCopied] = useState(false)
    const [region, setRegion] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [size, setSize] = useState(0)

    const OpenSelectedModal = () => {
        setOpenModal(true)
    }

    const title_empty = "Create your firts collection"
    const title_item = "Choose a collection"
    const subtitle_empty = "Collections are like boxes for your data: create a box and start filling it with everything you need."
    const img_empty = "json"

    const title_empty_col = "This collection is empty!"
    const subtitle_empty_col = "Data can be inserted through APIs or directly via the platform."
    const img_empty_col = "json"

    useEffect(() => {
        if (project_id && db_id && coll_id) {
            fetchCollection(user_id, db_id, coll_id, currentPage);
        }
    }, [user_id, project_id, db_id, coll_id, currentPage]);


    const handleOpenCollection = (coll_id) => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/data/${coll_id}`)
    }

    const fetchCollection = async (user_id, db_id, coll_id, page = 1) => {
        setLoadingCollection(true);
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_collection", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    db_id,
                    coll_id,
                    page,
                }),
            });
            if (response.ok) {
                const result = await response.json();
                const collection = result.records || [];
                setCollectionData(Array.isArray(collection) ? collection : []);
                setRegion(result.region);
                setTotalRecords(result.totalRecords);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load files.");
            }
        } catch (err) {
            setError("Failed to connect to the server. Please try again later.");
        } finally {
            setLoadingCollection(false);
        }
    };



    const showApiConnection = (coll_det) => {
        setShowApiConn(true)
        setCollectionDetails(coll_det)
    }

    const showModalNewRec = (coll_det) => {
        setOpenModalNewRec(true)
        setCollectionDetails(coll_det)
    }

    const handleDeleteClick = (coll_id) => {
        setShowDeleteModal(true)
        const selectedRecord = records.find((item) => item.collections[coll_id].coll_id === coll_id);
        if (selectedRecord) {
            const obj = {
                _id: {
                    db_id: db_id,
                    coll_id: coll_id,
                }
            }
            setRecordObject(obj)
        }
    }

    const handleClose = () => {
        setShowDeleteModal(false)
        setRecordObject({})
    }


    const RefreshCollection = () => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/data`)
        fetchRecords()
    }

    function handlePageChange(action) {
        const totalPages = Math.ceil(totalRecords / 50);

        if (action === "first") {
            setCurrentPage(1);
        } else if (action === "last") {
            setCurrentPage(totalPages);
        } else if (action === "prev" && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (action === "next" && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    }


    const handleCopyClick = () => {
        navigator.clipboard.writeText(coll_id);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    useEffect(() => {
        if (!records || !coll_id) return;

        const allCollections = records.flatMap(r =>
            Object.values(r.collections || {})
        );

        const selected = allCollections.find(c => c.coll_id === coll_id);

        if (selected) {
            setSize(selected.current_size_mb);
        }
    }, [records, coll_id]);



    if (error) {
        return <ErrorPage />;
    }

    return (
        <div className="open_db_main_entire_body">
            <div className="open_db_main_header fade-in">
                {records.some(record =>
                    record.collections &&
                    Object.keys(record.collections).length > 0
                ) && (
                        <>
                            {/* <button className={`open_db_main_header_btns ${viewType === "code_editor" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("code_editor")}><BiLogoPython /> Python editor</button> */}
                            {/* <button className={`open_db_main_header_btns ${viewType === "json_view" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("json_view")}>JSON view</button> */}
                            {/* <button className={`open_db_main_header_btns ${viewType === "table_view" ? "open_db_main_header_btn_selected" : ""}`} onClick={() => setViewType("table_view")}>Table view</button> */}
                        </>
                    )}
            </div>

            <div className="open_db_main_body fade-in">
                <div className={`${records.some(record =>
                    record.collections &&
                    Object.keys(record.collections).length > 0
                ) ? "open_db_main_sidebar_opened" : "open_db_main_sidebar"}`}>

                    <div className="open_db_main_sidebar_header">
                        <div className="open_db_main_sidebar_header_title">
                            <p>
                                <BsCollection /> Collections
                            </p>
                            <div className="open_db_main_sidebar_header_title_btn_cont">
                                <button className="open_db_main_sidebar_header_title_btn" onClick={OpenSelectedModal}><TbPlus /></button>
                                <button className="open_db_main_sidebar_header_title_btn" onClick={fetchRecords}><TbReload /></button>
                            </div>
                        </div>
                    </div>
                    <div className="open_db_main_sidebar_body fade-in">

                        {records.map((record, index) => {
                            const collections = record.collections;

                            const collectionsArray = collections && typeof collections === "object"
                                ? Object.values(collections)
                                : [];

                            return collectionsArray.map((collection) => (
                                <div key={collection.coll_id} className={`open_db_main_sidebar_body_link ${coll_id == collection.coll_id ? "open_db_main_sidebar_body_link_selected" : ""}`} >
                                    <p onClick={() => handleOpenCollection(collection.coll_id)}>- {collection.coll_name}</p>
                                    <Dropdown>
                                        <div className="property_btn_action_toggle">
                                            <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                <Dropdown.Item
                                                    className="drop_down_item delete"
                                                    onClick={() => handleDeleteClick(collection.coll_id)}
                                                >
                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                </div>
                            ));
                        })}
                    </div>
                </div>
                {records.some(record =>
                    record.collections &&
                    Object.keys(record.collections).length > 0
                ) ? (
                    <div className="open_db_body">
                        {coll_id ? (
                            <>
                                <div className="open_db_body_header fade-in">
                                    {
                                        records.map(record => {
                                            const collections = record.collections || {};
                                            const collectionsArray = Object.values(collections);

                                            const selectedCollection = collectionsArray.find(
                                                collection => collection.coll_id === coll_id
                                            );


                                            if (selectedCollection) {
                                                return (
                                                    <div key={selectedCollection.coll_id} className="open_db_body_header_dets">
                                                        <div className="collection_details_cont">
                                                            <div className="connection_btn_cont">
                                                                {/* <button className="connection_btn" onClick={() => showModalNewRec(user_id, db_id, coll_id)}><i><BiPlus /></i></button> */}
                                                                <button className="connection_btn" onClick={() => fetchCollection(user_id, db_id, coll_id)}><i><TbReload /></i></button>
                                                                <button className="connection_btn" onClick={() => showApiConnection(selectedCollection)}><i><BiQuestionMark /></i> </button>
                                                            </div>
                                                            <div>
                                                                <p className="coll_title">
                                                                    {selectedCollection.coll_name}
                                                                    <span className={`${coll_id ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                                                                        {coll_id}
                                                                        {coll_id && (
                                                                            <i onClick={handleCopyClick}>
                                                                                {copied ? (
                                                                                    <i className="fa-solid fa-check fade-in"></i>
                                                                                ) : (
                                                                                    <i>
                                                                                        <BiCopy className="fade-in" />
                                                                                    </i>
                                                                                )}
                                                                            </i>
                                                                        )}
                                                                    </span>

                                                                </p>
                                                                <p className="coll_desc">
                                                                    <span className="coll_desc_span" title={selectedCollection.coll_desc}>{selectedCollection.coll_desc}</span>
                                                                </p>


                                                            </div>

                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })
                                    }
                                </div>

                                {loadingCollection ? (
                                    <div className="body_loading_db_cont fade-in">
                                        <div className="loading_logo_erioon">
                                            <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {collectionData.length > 0 ? (
                                            <>
                                                {viewType === "json_view" ? (
                                                    <OpenCollectionJson
                                                        collectionData={collectionData}
                                                        fetchCollection={fetchCollection}
                                                    />
                                                ) : viewType === "table_view" ? (
                                                    <OpenCollectionTable
                                                        collectionData={collectionData}
                                                        fetchCollection={fetchCollection}
                                                        currentPage={currentPage}
                                                    />
                                                ) : (
                                                    <CodeEditor />
                                                )}
                                            </>
                                        ) : viewType == "code_editor" ? (
                                            <CodeEditor />

                                        ) : (
                                            <NoDataItem
                                                fetchRecords={fetchRecords}
                                                title={title_empty_col}
                                                subtitle={subtitle_empty_col}
                                                item={img_empty}
                                                showBtn={false}
                                                dbType={"nosql"}
                                            />
                                        )}
                                    </>
                                )}


                                {totalRecords > 0 && (
                                    <div className="collection_footer_cont">
                                        <div className="page_indicator_cont">
                                            <button
                                                onClick={() => handlePageChange("first")}
                                                disabled={currentPage === 1 || loadingCollection}
                                            >
                                                <i className=""><LuChevronFirst /></i>
                                            </button>

                                            <button
                                                onClick={() => handlePageChange("prev")}
                                                disabled={currentPage === 1 || loadingCollection}
                                            >
                                                <i className="fa-solid fa-chevron-left"></i>
                                            </button>

                                            <p className="page_indicator_cont_pages">
                                                {currentPage} / {Math.ceil(totalRecords / 50)}
                                            </p>

                                            <button
                                                onClick={() => handlePageChange("next")}
                                                disabled={currentPage >= Math.ceil(totalRecords / 50) || loadingCollection}
                                            >
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </button>

                                            <button
                                                onClick={() => handlePageChange("last")}
                                                disabled={currentPage >= Math.ceil(totalRecords / 50) || loadingCollection}
                                            >
                                                <i className=""><LuChevronLast /></i>
                                            </button>
                                        </div>
                                        <div className="total_records_coll">
                                            <p>

                                                {size >= 1000
                                                    ? `${(size / 1024).toFixed(2)} GB`
                                                    : `${size.toFixed(2)} MB`}
                                            </p>
                                            {Number(totalRecords) <= 1 ? (
                                                <p>
                                                    {totalRecords} record
                                                </p>
                                            ) : (
                                                <p>
                                                    {totalRecords} total records
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <NoDataItem
                                fetchRecords={fetchRecords}
                                title={title_item}
                                subtitle={subtitle_empty}
                                item={img_empty}
                                showBtn={false}
                                dbType={"nosql"}
                            />

                        )}
                    </div>
                ) : (
                    <NoDataItem
                        fetchRecords={fetchRecords}
                        title={title_empty}
                        subtitle={subtitle_empty}
                        item={img_empty}
                        showBtn={true}
                        dbType={"nosql"}
                    />
                )}


            </div>
            <NewCollectionModal
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchRecords}
            />
            <APIConnectorModal
                show={showAPIConn}
                handleClose={() => setShowApiConn(false)}
                collectionDetails={collectionDetails}
                db_id={db_id}
                region={region}
            />
            <NewRecordCollectionModal
                show={openModalNewRec}
                handleClose={() => setOpenModalNewRec(false)}
                user_id={user_id}
                db_id={db_id}
                coll_id={coll_id}
                fetchCollection={fetchCollection}
            />
            <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleClose}
                recordObject={recordObject}
                fetchRecords={RefreshCollection}
                endpoint={"delete_specific_collection"}
                record_type={"Delete"}
                message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
            />
        </div>

    )
}

export default MainData